import { observer } from 'mobx-react-lite';
import LanguageStore from '../../store/LanguageStore';
import VideoListStore from '../../store/VideoListStore';
import './page-title.scss';


const PageTitle = observer(() => {
    return (
        <h1 className="page-title">
            {LanguageStore.t('title', VideoListStore.trackedAt)}
        </h1>
    );
});

export default PageTitle;